export class OrganizationPaymentMethod {
  organizationId: string;
  paymentMethodId: string;
  preferred: boolean;
  modified: Date;
  addedByUser: string;

  constructor(json: any) {
    this.organizationId = json.organizationId;
    this.paymentMethodId = json.paymentMethodId;
    this.preferred = json.preferred;
    this.modified = json.modified ? new Date(json.modified) : new Date();
    this.addedByUser = json.addedByUser;
  }
}
